import React from 'react';
import { useTranslation } from 'react-i18next';

import { Wrapper } from '../../../components/Wrapper';
import { InterfaceWrapper } from '../../../components/InterfaceWrapper';
import { PlayerInterface } from './PlayerInterface';

import styled from 'styled-components';
import yellowStrategy from '../../../assets/YellowStrategy.png';
import { colorConfig } from '../../../config/colors';
import { StrategyHeader } from '../../../components/StrategyHeader';

const Box = styled.div`
  gap: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h1,
  h2 {
    text-align: center;
  }
  img {
    margin-left: -100px;
  }
`;

export const Rules8 = InterfaceWrapper({
  Interface: PlayerInterface,
  Step: ({ data }) => {
    const { t } = useTranslation();

    return (
      <Wrapper>
        <Box>
          <img src={yellowStrategy} alt="yellow" height="300px" />
          <div>
            <StrategyHeader>
              <h1
                dangerouslySetInnerHTML={{ __html: t('fishery.rules8', { strategyColor: colorConfig.yellow.card }) }}
              />
            </StrategyHeader>
            <h2>{t('fishery.rules8a')}</h2>
          </div>
        </Box>
      </Wrapper>
    );
  },
});
